import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { authApi } from "@/api/auth.ts";
import { Alert, Button, Field, Input, PageTitle } from "@/ui/primitives.tsx";
import { useApiError } from "@/ui/useApiError.ts";
import { AuthLayout } from "./AuthLayout.tsx";

export function RegisterPage({ initialInvite = "" }: { initialInvite?: string }) {
  const { t } = useTranslation();
  const toMsg = useApiError();
  const nav = useNavigate();
  const [form, setForm] = useState({ inviteCode: initialInvite, email: "", name: "", password: "" });
  const m = useMutation({
    mutationFn: () => authApi.register(form),
    onSuccess: (res) => void nav({ to: "/verify", search: { pending: res.pendingUserId, sentTo: res.sentTo, expiresAt: res.expiresAt } }),
  });
  return (
    <AuthLayout>
      <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); m.mutate(); }}>
        <PageTitle title={t("register.title")} subtitle={t("register.subtitle")} />
        {m.error && <Alert tone="danger">{toMsg(m.error)}</Alert>}
        <Field label={t("register.inviteCode")}>
          <Input dir="ltr" required autoFocus={!initialInvite} className="font-mono uppercase" placeholder="XXXXX-XXXXX-XXXXX-XXXXX" value={form.inviteCode} onChange={(e) => setForm({ ...form, inviteCode: e.target.value })} />
        </Field>
        <Field label={t("common.name")}>
          <Input required autoFocus={!!initialInvite} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </Field>
        <Field label={t("common.email")}>
          <Input type="email" dir="ltr" required autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label={t("common.password")} hint={t("common.passwordHint")}>
          <Input type="password" dir="ltr" required minLength={12} autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </Field>
        <Button type="submit" className="w-full" loading={m.isPending}>{t("register.submit")}</Button>
        <p className="text-center text-sm text-fg-muted">
          {t("register.haveAccount")} <Link to="/login" className="text-accent hover:underline">{t("register.login")}</Link>
        </p>
      </form>
    </AuthLayout>
  );
}
